import React, { Component } from 'react';
import { access_token } from '../../../server/constants'
import { groupBy } from '../../../server/util'

class districtSchoolCard extends Component {
    render() {
        const { school, schoolDropdownData } = this.props;
        const schoolDDGroup = groupBy((schoolDropdownData || []), 'schoolId');
        return (
            <div className="pricingTable">
                <div className="priceUper">
                    <div className="priceTitle bg-color-1"><h3>District Summary</h3></div>
                </div>
                <table>
                    <thead style={styles.HeaderStyle}>
                        <tr>
                            <td width={'*'} style={{ textAlign: "left" }}><span>Site</span></td>
                            <td width={'10%'}>Total Staff</td>
                            <td width={'10%'}>Total Students</td>
                            <td width={'10%'}>New Students</td>
                            <td width={'10%'}>Free</td>
                            <td width={'10%'}>Reduced</td>
                            <td width={'10%'}>Regular</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            school.map(item => {
                                const subdomain = ((schoolDDGroup[item.mealSchoolId] || [])[0] || {}).subdomain || '';
                                const protocal = window.location.protocol;
                                const mainDomain = window.location.host.replace(window.location.host.split('.')[0], '');
                                return (
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            <span>{item.schoolName} <a href="javascript:void(0);" onClick={() => {
                                                const refresh_token = sessionStorage.getItem('refresh_token') || '';
                                                const url = `${protocal + '//' + subdomain + mainDomain}?${btoa(`akey=${access_token()}&rkey=${refresh_token}`)}`
                                                window.open(
                                                    url,
                                                    '_blank' // <- This is what makes it open in a new window.
                                                );
                                            }}><i className="fa fa-external-link"></i></a></span>


                                        </td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).Staff || 0}</td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).Total}</td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).NewStudents}</td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).Free}</td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).Reduced}</td>
                                        <td style={{ textAlign: "center" }}>{(item.ledger || {}).Regular}</td>
                                    </tr>)
                            })
                        }
                    </tbody>
                </table>
            </div>

        );
    }
}

const styles = {
    linkStyle: {

        textAlign: "center",
        marginLeft: 10,
        paddingBottom: 10

    },
    HeaderStyle: {
        marginTop: 10,
        marginLeft: 10,
        color: "red",
        marginBottom: 10,
        textAlign: "center",


    }
}

export default districtSchoolCard;




// WEBPACK FOOTER //
// ./src/components/District/Home/districtSchoolCardNew.jsx